import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    width: 100%;
    min-width: 100%;
    /* Mais altura que 240px: alinha melhor com a sensação visual do banner na borracharia_major */
    min-height: 300px;
    height: 300px;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    background: linear-gradient(135deg, #0a0e27 0%, #0f3460 40%, #00d4ff 80%, #0099cc 100%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    ${(p) =>
        p.$mobileHeight &&
        `
        @media (max-width: 767px) {
            min-height: ${p.$mobileHeight}px;
            height: ${p.$mobileHeight}px;
        }
    `}

    /* /plans mobile: faixa escura da página sobe — texto fica só no fundo escuro sem empurrar o bloco */
    ${(p) =>
        !p.$mobileHeight &&
        p.$shortMobileGradient &&
        `
        @media (max-width: 767px) {
            /* ~248px: junção azul/escuro no meio do botão “Acesso completo” (260px baixava demais a linha) */
            min-height: 248px;
            height: 248px;
        }
    `}

    :after {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
        background: inherit;
        transform-origin: top right;
        ${(props) => (props.isDiagonal ? 'transform: skewY(-3deg);' : '')};
    }
`;
